define.alias("shared/components/shared/pre-boarding/social-connect/index", "calendar/components/shared/pre-boarding/social-connect/index");